import * as React from "react";
import { getFormattedDateTime } from "../../helpers/dateTimeUtils";
import { NoValue } from "../NoValue/NoValue";

export interface DateTimeDisplayProps {
  date: Date | undefined;
}

/**
 * The DateTimeDisplay component can be used to display the datetime
 * in MM/DD/YYYY HH:MM:SS AM/PM format
 */
export const DateTimeDisplay = ({ date }: DateTimeDisplayProps): JSX.Element => {
  if (date) {
    return <>{getFormattedDateTime(date)}</>;
  }
  return <NoValue />;
};
